import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { RiFileExcel2Line, RiFilePdf2Line } from "react-icons/ri";
import { toast, ToastContainer } from "react-toastify";
import { Button, ButtonGroup, Table } from "reactstrap";
import swal from "sweetalert";
import { LoadingSpinner } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { GetLanguageString, NoResult } from "../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import { ShowToast } from "../../shared/ShowToast";
import { ApiEvent } from "../ApiEvent";
import SearchEventAttendance from "./SearchEventAttendance";
const UnitWiseEventAttendance = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [loading, setLoading] = useState(false);
  const [searchButton, setSearchButton] = useState(false);
  const [data, setData] = useState({});

  let tempDate = new Date();
  tempDate.setUTCDate(1);
  const [searchEventWiseAttendanceModel, setSearchEventWiseAttendanceModel] =
    useState({
      unit: { value: loggedInUnitId, lable: "" },
      isSubUnits: true,
      startDate: tempDate,
      endDate: new Date(),
      eventTypeIds: [],
    });

  useEffect(() => {
    if (searchButton) {
      setLoading(true);
      ApiEvent()
        .GetUnitWiseEventAttendanceReport(searchEventWiseAttendanceModel)
        .then((res) => {
          setData(res.data.report);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    }
  }, [searchButton, searchEventWiseAttendanceModel]);
  const downloadExcel = () => {
    if (searchButton) {
      const toastId = toast.loading(t("downloading_excel"));
      ApiEvent()
        .GetUnitWiseEventAttendanceExcelReport(searchEventWiseAttendanceModel)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "NazamWiseIjtimaReport.xlsx");
          ShowToast(toastId, "downloaded_excel", "success");
        })
        .catch((err) => {
          console.log(err);
          ShowToast(toastId, "Failed to download Excel.", "error");
        })
        .then(() => {});
    }
  };
  const downloadPdf = () => {
    if (searchButton) {
      const toastId = toast.loading(t("downloading_pdf"));
      ApiEvent()
        .GetUnitWiseEventAttendancePdfReport(searchEventWiseAttendanceModel)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/pdf",
          });
          saveAs(blob, "NazamWiseIjtimaReport.pdf");
          ShowToast(toastId, "downloaded_pdf", "success");
        })
        .catch((err) => {
          console.log(err);
          ShowToast(toastId, "Failed to download Pdf.", "error");
        })
        .then(() => {
          setLoading(false);
        });
    }
  };
  // the Ahbab column only appears when some row has ahbab to show
  const showAhbab = Array.isArray(data) && data.some((item) => (item.ahbab ?? 0) > 0);

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <div className="ibox">
        <div className="ibox-title">
          <h5>{<GetLanguageString props="common_generate_report" />}</h5>
          <Button
            color="primary"
            size="sm"
            className={GetCustomStyles().btn_style}
            onClick={() => history.goBack()}
          >
            {<GetLanguageString props="courses_participants_back" />}
          </Button>
        </div>
        <SearchEventAttendance
          searchEventWiseAttendanceModel={searchEventWiseAttendanceModel}
          setSearchEventWiseAttendanceModel={setSearchEventWiseAttendanceModel}
          setSearchButton={setSearchButton}
        />
      </div>
      <ToastContainer
        autoClose={3000}
        bodyClassName={GetSelectedLanguage()}
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      {searchButton ? (
        <div className="ibox">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="quick_event_reports_button3" />}</h5>
            <ButtonGroup className={GetCustomStyles().btn_style}>
              <Button color="default" size="sm" onClick={downloadExcel}>
                <RiFileExcel2Line
                  size={15}
                  color="#009440"
                  style={{ marginRight: 3, marginBottom: 1 }}
                />
                {<GetLanguageString props="member_report_export_excel" />}
              </Button>
              <Button color="default" size="sm" onClick={downloadPdf}>
                <RiFilePdf2Line
                  size={15}
                  color="#FF0000"
                  className={GetCustomStyles().fa_style}
                />
                {<GetLanguageString props="member_report_export_pdf" />}
              </Button>
            </ButtonGroup>
          </div>
          <div className="ibox-content">
            {!loading ? (
              data !== undefined &&
              data !== null &&
              Object.keys(data).length !== 0 ? (
                <div
                  className="panel-body ibox-center"
                  style={{ marginLeft: 100, marginRight: 100 }}
                >
                  <div className="table-responsive">
                    <Table hover className="table-bordered m-b-none" style={{ backgroundColor: "#ffffff" }}>
                      <thead>
                        <tr style={{ backgroundColor: "#f3f3f4" }}>
                          <th style={{ verticalAlign: "middle", textAlign: "center", minWidth: "140px" }}>
                            <GetLanguageString props="member_member_detail_unit_history" />
                          </th>
                          <th style={{ verticalAlign: "middle", textAlign: "center" }}>
                            <GetLanguageString props="report_member_mubtadi" />
                          </th>
                          <th style={{ verticalAlign: "middle", textAlign: "center" }}>
                            <GetLanguageString props="report_member_multazim" />
                          </th>
                          <th style={{ verticalAlign: "middle", textAlign: "center" }}>
                            <GetLanguageString props="report_member_mutazir" />
                          </th>
                          <th style={{ verticalAlign: "middle", textAlign: "center" }}>
                            <GetLanguageString props="report_member_tawajah_talab" />
                          </th>
                          {showAhbab && (
                            <th style={{ verticalAlign: "middle", textAlign: "center" }}>
                              <GetLanguageString props="unit_ahbaab" />
                            </th>
                          )}
                          <th
                            style={{
                              verticalAlign: "middle",
                              textAlign: "center",
                              backgroundColor: "#eafaf1",
                              borderBottom: "2px solid #1ab394",
                              color: "#065f46",
                            }}
                          >
                            <GetLanguageString props="report_vacant_responsibilities_total" />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item, index) => {
                          const isTotalRow = item.name === "ٹوٹل" || item.name === "کل";
                          return (
                            <tr
                              key={index}
                              style={{
                                backgroundColor: isTotalRow ? "#f4fbf7" : "inherit",
                                fontWeight: isTotalRow ? "bold" : "normal",
                              }}
                            >
                              <td
                                className="text-center ur"
                                style={{
                                  verticalAlign: "middle",
                                  padding: "8px 6px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "6px",
                                    flexDirection: "row-reverse",
                                  }}
                                >
                                  <span
                                    className={isTotalRow ? "label label-primary" : "label label-info"}
                                    style={{
                                      borderRadius: "10px",
                                      padding: "2px 6px",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                      lineHeight: 1.2,
                                      minWidth: "20px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {item.eventCounts}
                                  </span>
                                  <span style={{ fontSize: "1.05rem" }}>
                                    {item.name}
                                  </span>
                                </div>
                              </td>
                              <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                {`${item.attendeMubtadi ?? 0} / ${item.totalMubtadi ?? 0}`}{" "}
                                ({item.mubtadi ? item.mubtadi.toFixed(2) + "%" : "0.0%"})
                              </td>
                              <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                {`${item.attendeMultazim ?? 0} / ${item.totalMultazim ?? 0}`}{" "}
                                ({item.multazim ? item.multazim.toFixed(2) + "%" : "0.0%"})
                              </td>
                              <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                {`${item.attendeMutazir ?? 0} / ${item.totalMutazir ?? 0}`}{" "}
                                ({item.mutazir ? item.mutazir.toFixed(2) + "%" : "0.0%"})
                              </td>
                              <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                {`${item.attendeTawajahTalab ?? 0} / ${item.totalTawajahTalab ?? 0}`}{" "}
                                ({item.tawajahTalab ? item.tawajahTalab.toFixed(2) + "%" : "0.0%"})
                              </td>
                              {showAhbab && (
                                <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                  {item.ahbab ?? 0}
                                </td>
                              )}
                              <td
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                  backgroundColor: isTotalRow ? "#eafaf1" : "#f4fbf7",
                                  fontWeight: "bold",
                                  color: "#1ab394",
                                }}
                              >
                                {item.totalPercentage
                                  ? item.totalPercentage.toFixed(2) + "%"
                                  : "0.0%"}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              ) : (
                <NoResult />
              )
            ) : (
              LoadingSpinner()
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default UnitWiseEventAttendance;
